
import { CaseStudyTemplate } from '@/components/case-studies/CaseStudyTemplate';
import { faSearch, faBell, faLink } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

export default function ShopliftingDetectionCaseStudy() {
  const { t } = useTranslation();
  return (
    <CaseStudyTemplate
      id="shoplift"
      title={t('caseStudies.shoplift.title')}
      description={t('caseStudies.shoplift.description')}
      video="/shoplifting.mp4"
      image="/images/case-studies/shoplifting-prevention-hero.jpg"
      problem={t('caseStudies.shoplift.problem')}
      solution={t('caseStudies.shoplift.solution')}
      results={t('caseStudies.shoplift.results')}
      features={[
        {
          title: t('caseStudies.shoplift.features[0].title'),
          description: t('caseStudies.shoplift.features[0].description'),
          icon: faSearch
        },
        {
          title: t('caseStudies.shoplift.features[1].title'),
          description: t('caseStudies.shoplift.features[1].description'),
          icon: faBell
        },
        {
          title: t('caseStudies.shoplift.features[2].title'),
          description: t('caseStudies.shoplift.features[2].description'),
          icon: faLink
        }
      ]}
      faqs={t('caseStudies.shoplift.faq', { returnObjects: true }) as Array<{id?: string, question: string, answer: string}>}
    />
  );
}
